import { useState } from 'react';
import type { AppConfig } from '@avs/contract';
import { useApp } from '../state/AppContext.js';
import { showToast } from '../hooks/useToasts.js';
import { Modal } from './Modal.js';
import { Field } from './Field.js';
import { Button } from './Button.js';
import { Icon } from '../icons/Icon.js';

type Props = {
  open: boolean;
  onClose: () => void;
};

/**
 * Slice 8 起：存储换 Cloudflare R2、模型换 fal.ai，凭证全部走服务端环境变量，
 * 前端不再收集任何 AK/SK。欢迎弹窗只剩「输出位置（可选）」+ 架构说明。
 */
export function WelcomeConfigModal({ open, onClose }: Props) {
  const { state, actions } = useApp();
  const [output, setOutput] = useState(state.config.output);

  function applyAndEnter() {
    const next: Partial<AppConfig> = { output };
    actions.updateConfig(next);
    showToast('已进入工作台', 'ok');
    onClose();
  }
  function skipForNow() {
    showToast('已进入，可稍后在「设置」调整');
    onClose();
  }

  return (
    <Modal
      open={open}
      onClose={skipForNow}
      size="md"
      title="欢迎使用 AI 视频创作 Studio"
      desc="视频替换 · 批量任务管理。存储（Cloudflare R2）与模型（fal.ai）凭证由运维侧在服务端配置，前端不收集任何密钥，开箱即用。"
      footer={
        <>
          <Button variant="ghost" onClick={skipForNow}>直接进入</Button>
          <Button variant="primary" leftIcon={<Icon name="check" size={16} />} onClick={applyAndEnter}>
            进入工作台
          </Button>
        </>
      }
    >
      <Field label="默认输出位置（选填）" hint="新建任务时默认填入这里；留空也行，可在任务表单里单独填。">
        <input
          className="input"
          placeholder="r2://avs-assets/output/"
          value={output.bucket}
          onChange={(e) => setOutput({ ...output, bucket: e.target.value })}
        />
      </Field>
      <div className="alert alert-warn" style={{ marginTop: 'var(--space-s)' }}>
        <Icon name="info" size={16} />
        <div className="alert-body small">
          素材上传走服务端 R2，模型走 fal.ai —— 你不需要在这里填任何 AK/SK 或 API Key。
          运维侧的配置见 <code>docs/operator-deployment.md</code>。
        </div>
      </div>
    </Modal>
  );
}
